import { GAME_CONFIG, type GameConfig } from './config';
import type { Rarity } from './rarity';

export function fragmentsForDuplicate(rarity: Rarity, config: GameConfig = GAME_CONFIG): number {
  return config.rarities[rarity].fragmentsPerDuplicate;
}

export interface UpgradeStep {
  fromLevel: number;
  toLevel: number;
  
  cost: number;
  
  totalCost: number;
  unlock: string;
}

export function maxUpgradeLevel(config: GameConfig = GAME_CONFIG): number {
  return Math.max(...config.upgrades.map((level) => level.level));
}

export function getUpgradeStep(currentLevel: number, config: GameConfig = GAME_CONFIG): UpgradeStep | null {
  const current = config.upgrades.find((level) => level.level === currentLevel);
  const next = config.upgrades.find((level) => level.level === currentLevel + 1);
  if (!current || !next) return null;
  return {
    fromLevel: current.level,
    toLevel: next.level,
    cost: next.totalCost - current.totalCost,
    totalCost: next.totalCost,
    unlock: next.unlock,
  };
}


export const FRAGMENT_ANIMA_PERCENT = 10;


export function fragmentsToAnima(rarity: Rarity, fragments: number, config: GameConfig = GAME_CONFIG): number {
  const { baseValue, fragmentsPerDuplicate } = config.rarities[rarity];
  const count = Math.max(0, Math.floor(fragments));
  return Math.floor((count * baseValue * FRAGMENT_ANIMA_PERCENT) / (fragmentsPerDuplicate * 100));
}
